import { render, staticRenderFns } from "./ShoppingListCart.vue?vue&type=template&id=08e6519f&"
import script from "./ShoppingListCart.vue?vue&type=script&lang=js&"
export * from "./ShoppingListCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports